import { Switch } from '@mui/material';
import styled from 'styled-components';

export const SPWSwitch = styled(Switch)`
  .MuiSwitch-thumb {
    height: 16px;
    width: 16px;
    transform: translateY(2px);
  }

  .MuiButtonBase-root:hover {
    background-color: transparent;
  }

  .MuiTouchRipple-root {
    display: none;
  }

  &.no-padding-right {
    width: 46px;
    padding-right: 0;
  }
`;
